// api.js
/**
 * Централізований модуль для API запитів
 */
(window as any).bbApi = {
    async get(endpoint) {
        try {
            const res = await fetch(`api/${endpoint}`);
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            return await res.json();
        } catch (e) {
            console.error(`GET ${endpoint} failed:`, e);
            throw e;
        }
    },
    
    async post(endpoint, data) {
        try {
            const res = await fetch(`api/${endpoint}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            });
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            return await res.json();
        } catch (e) {
            console.error(`POST ${endpoint} failed:`, e);
            throw e;
        }
    },
    
    async delete(endpoint, id) {
        try {
            const res = await fetch(`api/${endpoint}?action=delete&id=${id}`);
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            return await res.json();
        } catch (e) {
            console.error(`DELETE ${endpoint} failed:`, e);
            throw e;
        }
    }
};
